import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import SpacerElement from '@deliveroo/consumer-component-library/internal/SpacerElement';
import PromoBanner from '@deliveroo/consumer-component-library/components/PromoBanner';
import ServiceBanner from '@deliveroo/consumer-component-library/components/ServiceBanner';
import InfoBannerModalContainer from '../InfoBannerModal';

import { dispatchDeepLink } from '../../actions/deepLinkActions';
import { setInfoBannerModalIsOpen } from '../../actions/orderActions';
import { trackClickedInfoBanner } from '../../actions/tracking/orderStatus';

import { getOrderStatus } from '../../selectors/orderStatusSelectors';

export class InfoBannerContainer extends Component {
  render() {
    const {
      type,
      body,
      title,
      theme,
      badge,
      href,
      deepLinkUri,
      modalType,
      onClickedInfoBanner,
      spacing,
      adjacentVerticalSpacing,
      adjacentHorizontalSpacing,
      wrapperClasses,
    } = this.props;

    const commonInfoBannerProps = {
      shouldOpenInNewWindow: true,
      title,
      body,
      theme,
      href,
      onClick: () => onClickedInfoBanner(deepLinkUri, modalType),
    };

    return (
      <SpacerElement
        spacing={spacing}
        adjacentVerticalSpacing={adjacentVerticalSpacing}
        adjacentHorizontalSpacing={adjacentHorizontalSpacing}
        className={wrapperClasses}
      >
        {type === 'PROMO' && <PromoBanner {...commonInfoBannerProps} />}

        {type === 'SERVICE' && <ServiceBanner {...commonInfoBannerProps} badge={badge} />}

        {modalType && <InfoBannerModalContainer />}
      </SpacerElement>
    );
  }
}

InfoBannerContainer.defaultProps = {
  showInfoBanner: false,
  type: null,
  theme: 'berry',
  body: '',
  title: '',
  badge: null,
  modalType: null,
  href: null,
  deepLinkUri: null,
  onClickedInfoBanner: () => {},
  ...SpacerElement.defaultProps,
};

InfoBannerContainer.propTypes = {
  /**
   * Whether to show the info banner dependent on a feature variable,
   * whether it's a shared order and if there is info banner data
   */
  showInfoBanner: PropTypes.bool,
  /**
   * Whether the info banner should use a service or promo banner
   */
  type: PropTypes.oneOf(['SERVICE', 'PROMO']),
  /**
   * Message of the banner
   */
  body: PropTypes.string,
  /**
   * Title for the heading tag
   */
  title: PropTypes.string,
  /**
   * The colour theme for the banner
   */
  theme: PropTypes.oneOf(['white', 'teal', 'berry']),
  /**
   * Badge id used in styles to determine image used
   */
  badge: PropTypes.oneOf(['rider', 'alerts', 'download']),
  /**
   * If the banner is clickable, this is the href for the click target
   */
  href: PropTypes.string,
  /**
   * If the banner is clickable, this is the deep link uri to dispatch
   * a deep link action for the click target
   */
  deepLinkUri: PropTypes.string,
  /**
   * If the banner is clickable, this is the modal to open for the click target
   */
  modalType: PropTypes.string,
  /**
   * Function called when an info banner is clicked
   */
  onClickedInfoBanner: PropTypes.func,
  ...SpacerElement.propTypes,
};

export const mapStateToProps = (state) => {
  const status = getOrderStatus(state);
  const infoBanner = status.infoBanner;

  return {
    type: infoBanner && infoBanner.type,
    body: infoBanner && infoBanner.body,
    title: infoBanner && infoBanner.title,
    theme: infoBanner && infoBanner.theme,
    badge: infoBanner && infoBanner.badge,
    href: infoBanner && infoBanner.href,
    deepLinkUri: infoBanner && infoBanner.deepLinkUri,
    modalType: infoBanner && infoBanner.modalType,
  };
};

const mapActionsToProps = (dispatch) => ({
  onClickedInfoBanner: (deepLinkUri, modalType) => {
    dispatch(trackClickedInfoBanner());

    if (deepLinkUri) {
      dispatch(dispatchDeepLink(deepLinkUri));
    }

    if (modalType) {
      dispatch(setInfoBannerModalIsOpen(true));
    }
  },
});

export default connect(
  mapStateToProps,
  mapActionsToProps,
)(InfoBannerContainer);
